<template lang="html">
  <b-container>
    <b-row>
      <b-col>
        <h1>Group administration</h1>
        <b-table :items="$store.state.group_list" :fields="fields" class="mt-4">
          <template v-slot:cell(actions)="data">
            <b-btn
              size="sm"
              :to="{
                name: 'groups-edit',
                params: { id: data.item.key }
              }"
              class="mr-2 mb-1"
            >
              Edit Member List
            </b-btn>
            <b-btn
              size="sm"
              :to="{
                name: 'groups-edit-details',
                params: { id: data.item.key }
              }"
              class="mr-2 mb-1"
            >
              Edit Details
            </b-btn>
          </template>
          <template v-slot:cell(account_level)="data">
            <span v-if="data.item.plan_level == 'standard_annual'">
              Standard
            </span>
            <span v-if="data.item.plan_level == 'plus_annual'">
              Plus
            </span>
            <span v-if="data.item.plan_level == 'premium_annual'">
              Premium
            </span>
          </template>
          <template v-slot:cell(current_users)="data">
            {{ data.item.approved_email_addresses.length }}
          </template>
          <template v-slot:cell(description)="data">
            {{ data.item.all_visible_plan_description }}
          </template>
          <template v-slot:cell(valid_until)="data">
            {{ data.item.expiration_at | date_readable }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { format } from "date-fns";
export default {
  name: "Groups",
  filters: {
    date_readable(value) {
      return format(value.toDate(), "MMMM Do, YYYY");
    }
  },
  data() {
    return {
      fields: [
        "description",
        "account_level",
        "valid_until",
        "current_users",
        "user_limit",
        "actions"
      ]
    };
  }
};
</script>

<style lang="css" scoped></style>
